import Vue from 'vue';
import ContentService from './content.service.js';
import * as _ from 'lodash';
import abstractStore from '../../store/abstractstore';

export const getDefaultSort = () => ({ currentSort: 'name', currentSortDir: 'asc' });

const getDefaultItem = () => ({
    id: null,
    filename: '',
    contentFileTyp: 'hoerbtext',
    fileContent: '',
    assetId: null,
    parent: null,
});

const getDefaultState = () => ({
    item: getDefaultItem(),
    list: [],
    breadcrumb: [],
});

const content = {
    namespaced: true,

    state: Object.assign({}, getDefaultState()),

    mutations: {
        update(state, data) {
            Vue.set(state, 'item', data);
        },
        updateList(state, data) {
            Vue.set(state, 'list', data);
        },
        clear(state) {
            Vue.set(state, 'item', getDefaultState().item);
            Vue.set(state, 'list', getDefaultState().list);
        },

        setBreadcrumb(state, data) {
            Vue.set(state, 'breadcrumb', data);
        },
    },

    actions: {
        clear({ commit }) {
            commit('clear');
        },
        async update(context, client_data) {
            if (client_data.id == null) {
                delete client_data.id;
            }
            const { data } = await ContentService.update(client_data);
            context.commit('update', data);
            return data;
        },
        async get(context, id) {
            const { data } = await ContentService.get(id);
            context.commit('update', data);
            return data;
        },
        async query(context, params) {
            const { headers, data } = await ContentService.query(params);

            let currPage = params && params.params && params.params.page ? params.params.page : 0;
            context.commit('updateCurrentPage', currPage);

            let size = params && params.params && params.params.size ? params.params.size : 20;
            let totalCount = headers['x-total-count'];
            let totalPages = 1;

            if (_.toNumber(totalCount) > 0 && _.toNumber(size) > 0) {
                totalPages = _.toNumber(totalCount) / _.toNumber(size);
            }

            context.commit('updateTotalPages', _.ceil(totalPages));

            context.commit('updateList', data);
            return data;
        },
        async delete(context, slug) {
            await ContentService.delete(slug);
        },

        async setBreadcrumb(context, breadcrumb) {
            context.commit('setBreadcrumb', breadcrumb);
            return breadcrumb;
        },
    },

    getters: {
        data(state) {
            return state.item;
        },
        list(state) {
            return state.list;
        },
        breadcrumb(state) {
            return state.breadcrumb;
        },
    },
};

export default _.merge(content, abstractStore.getDefaultStore());
